<template>
    <div class="w-100">
        <input class="form-control form-control-sm custom-date-style" type="text" :id="`air-date-${index}`"
            v-model="date" :name="name" placeholder="วัน-เดือน-ปี เช่น 23-04-2025" @input="handleInputChange">
        <input type="hidden" name="th_date[]" v-model="thDate">
    </div>
</template>

<script>
import AirDatepicker from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';
import localeTh from 'air-datepicker/locale/th';
const Popper = require('popper.js').default
export default {
    props: ['index', 'name', 'value', 'container'],
    data() {
        return {
            thDate: false,
            datepicker: null,
        };
    },
    computed: {
        date: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);  // สำหรับ v-model ใน Vue 2
            }
        }
    },
    watch: {
        date(newVal) {
            if (this.datepicker && newVal) {
                // ตรวจสอบรูปแบบวันที่ที่ถูกต้อง (YYYY-MM-DD)
                const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
                if (dateRegex.test(newVal)) {
                    try {
                        const dateObj = new Date(newVal);
                        if (!isNaN(dateObj.getTime())) {
                            this.datepicker.selectDate(dateObj);
                        }
                    } catch (error) {
                        console.warn('Invalid date format:', newVal);
                    }
                }
            }
        }
    },
    mounted() {
        this.date = this.value;
        let _this = this;
        this.datepicker = new AirDatepicker(`#air-date-${this.index}`, {
            container: this.container,
            locale: localeTh,
            dateFormat(date) {
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = _this.thDate ? date.getFullYear() + 543 : date.getFullYear();
                return `${day}-${month}-${year}`;
            },
            navTitles: {
                days(dp) {
                    const currentViewDate = dp.viewDate || dp.selectedDates[0] || new Date();
                    const year = _this.thDate ? currentViewDate.getFullYear() + 543 : currentViewDate.getFullYear();
                    const monthName = dp.formatDate(currentViewDate, 'MMMM');
                    if (_this.thDate) {
                        return ` ${monthName} พ.ศ. ${year}`;
                    } else {
                        return ` ${monthName} ค.ศ. ${year}`;
                    }
                }
            },
            position({ $datepicker, $target, $pointer, done }) {
                let popper = new Popper($target, $datepicker, {
                    placement: 'top',
                    modifiers: [
                        {
                            name: 'flip',
                            options: {
                                padding: {
                                    top: 64
                                }
                            }
                        },
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 20]
                            }
                        },
                    ]
                })

                /*
                 Return function which will be called when `hide()` method is triggered,
                 it must necessarily call the `done()` function
                     to complete hiding process
                */
                return function completeHide() {
                    popper.destroy();
                    done();
                }
            },
            onSelect({ date, formattedDate, datepicker }) {
                _this.date = formattedDate;
            },
            buttons: [
                {
                    attrs: {
                        type: "button"
                    },
                    content(dp) {
                        return _this.thDate
                            ? 'ใช้ ค.ศ.'
                            : 'ใช้ พ.ศ.'
                    },
                    onClick(dp) {
                        _this.thDate = !_this.thDate

                        // ถ้ามีวันที่เลือกอยู่ ให้แปลงปี
                        if (_this.date) {
                            const parts = _this.date.split('-');
                            if (parts.length === 3) {
                                const day = parts[0];
                                const month = parts[1];
                                let year = parseInt(parts[2]);

                                // แปลงปี
                                if (_this.thDate) {
                                    // เปลี่ยนจาก ค.ศ. → พ.ศ.
                                    year = year + 543;
                                } else {
                                    // เปลี่ยนจาก พ.ศ. → ค.ศ.
                                    year = year - 543;
                                }

                                _this.date = `${day}-${month}-${year}`;
                            }
                        }

                        // อัปเดต datepicker
                        dp.update({
                            navTitles: {
                                days(dp) {
                                    const currentViewDate = dp.viewDate || dp.selectedDates[0] || new Date();
                                    const year = _this.thDate ? currentViewDate.getFullYear() + 543 : currentViewDate.getFullYear();
                                    const monthName = dp.formatDate(currentViewDate, 'MMMM');
                                    if (_this.thDate) {
                                        return ` ${monthName} พ.ศ. ${year}`;
                                    } else {
                                        return ` ${monthName} ค.ศ. ${year}`;
                                    }
                                }
                            }
                        })
                    }
                }
            ]
        })
    },
    methods: {
        handleInputChange(event) {
            const value = event.target.value;

            // ตรวจสอบรูปแบบวันที่ที่ถูกต้อง (YYYY-MM-DD)
            const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

            if (dateRegex.test(value)) {
                try {
                    const dateObj = new Date(value);
                    if (!isNaN(dateObj.getTime()) && this.datepicker) {
                        this.datepicker.selectDate(dateObj);
                        this.datepicker.setViewDate(dateObj);
                    }
                } catch (error) {
                    console.warn('Invalid date format:', value);
                }
            }
        }
    },
};
</script>
